import React from 'react';
import imagePhoto from '../assets/myImage.png';
import {MdOutlineKeyboardArrowRight} from 'react-icons/md';
import {Link} from "react-scroll";

export const Home = () => {
    return (
        <div id="home" className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800">
            <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4 md:flex-row">
                <div className="flex flex-col justify-center h-full">
                    <h2 className="text-4xl sm:text-7xl pt-48 font-bold text-white">
                        I'm a Front-End Developer
                    </h2>
                    <p className="text-gray-500 py-4 max-w-md text-2xl">
                        React + Redux + Typescript
                    </p>
                    <div>
                        <Link to="portfolio" smooth duration={500}
                            className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-green-500 cursor-pointer">
                            Portfolio
                            <span className="group-hover:rotate-90 duration-300">
                                <MdOutlineKeyboardArrowRight size={25} className="ml-1"/>
                            </span>
                        </Link>
                    </div>
                </div>
                <div>
                    <img src={imagePhoto} alt="my photo" className="rounded-2xl mx-auto w-2/3 shadow-2xl shadow-cyan-500 md:w-full"/>
                </div>
            </div>
        </div>
    );
};


